import {EventEmitter, Input, Output} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ResourceFormTransactionEvent, ResourceTransactionEvent} from '@catfeatures/types';
import {StyleType} from '@catui/types';
import {buildFormControlsFromSchema} from '@catuiform/shared/form-builder';
import {isNullOrUndefined} from 'util';
import {getDirtyFormValues} from "@catcore/utils/form-utils";

export abstract class EntityForm {

  @Input() resourceUri: string;
  @Output() onFormSubmit = new EventEmitter<ResourceFormTransactionEvent>();
  @Output() deleteResource = new EventEmitter<ResourceTransactionEvent>();

  @Input()
  get schema(): any {
    return this._schema;
  }

  set schema(value: any) {
    this._schema = value;
    this.updateForm();
  }

  @Input()
  get formData(): any {
    return this._formData;
  }

  set formData(formData: any) {
    this._formData = formData;

    this.updateForm();
    this.patchFormValues(this._formData);
    this.onEntityReceived(this._formData);
  }

  displayDelete = true;

  protected _schema: any;
  protected _formData: any;

  private ignoreFieldsOnUpdate: string[] = [];
  private submitNullValueFields: string[] = [];

  form: FormGroup;

  constructor(private formBuilder: FormBuilder) {
  }

  protected onEntityReceived(value: any) {
  }

  getFormBuilder() {
    return this.formBuilder;
  }

  deleteModel($event) {
    this.deleteResource.emit({
      ref: this.resourceUri,
      success: () => this.afterDelete(),
      failure: () => this.afterDeleteFailed(),
    });
  }

  protected afterDelete() {
  }

  protected afterDeleteFailed() {
  }

  protected getFormData() {
    return this.formData;
  }

  /**
   * A more suitable alias for ::getFormData
   */
  protected getModel() {
    return this.getFormData();
  }

  protected setUpdateIgnore(fieldNameList: string[]) {
    this.ignoreFieldsOnUpdate = fieldNameList;
  }

  protected setSubmitNullValueFields(fieldNameList: string[]) {
    this.submitNullValueFields = fieldNameList;
  }

  private patchFormValues(formData: any) {

    if (this.form) {
      const formControlKeys = Object.keys(formData);
      const patchableValues = {};
      formControlKeys.forEach((formControlKey) => {
        patchableValues[formControlKey] = formData[formControlKey];
      });

      this.form.patchValue(patchableValues);
    }
  }

  protected beforeUpdateForm() {
  }

  protected afterUpdateForm(form: FormGroup) {
  }

  private updateForm() {

    let requirementsFullfilled = this.schema && Object.keys(this.schema).length > 0;
    requirementsFullfilled = requirementsFullfilled && this.formData && Object.keys(this.formData).length > 0;

    if (requirementsFullfilled) {
      this.beforeUpdateForm();
      const formControls = buildFormControlsFromSchema(this.formBuilder, this.schema, this.formData);
      this.form = this.formBuilder.group(formControls);
      this.afterUpdateForm(this.form);
    }

  }

  private cleanupFormValuesBeforeUpdate(formValues: any): any {
    let updatedFormValues = formValues;
    const propertyNames = Object.keys(formValues);

    updatedFormValues = this.modifyUpdatedFormValues(updatedFormValues);
    propertyNames.forEach((propertyName) => {
      let ignoreField = this.ignoreFieldsOnUpdate.length > 0 && this.ignoreFieldsOnUpdate.includes(propertyName);

      if (isNullOrUndefined(updatedFormValues[propertyName])
        && !this.submitNullValueFields.includes(propertyName)) {
        ignoreField = true;
      }

      if (ignoreField) {
        delete updatedFormValues[propertyName];
      }

    });

    return updatedFormValues;
  }

  onSubmit() {
    const formValues = this.cleanupFormValuesBeforeUpdate(
      getDirtyFormValues(this.form)
    );
    this.onFormSubmit.emit({
        resourceUri: this.resourceUri,
        formData: formValues,
        success: (result: any) => this.afterFormSubmit(result),
        failure: () => this.afterFormSubmitFailed(),
      },
    );
  }

  isDisabled(propertyName: string): boolean {
    return true;
  }

  protected afterFormSubmit(result: any) {
  }

  protected afterFormSubmitFailed() {
  }

  protected modifyUpdatedFormValues(values: any[]): any[] {
    return values;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/ui-models/shared/entity-form.ts